import { render } from "./AppEventview.vue?vue&type=template&id=2c5680b5"
import script from "./AppEventview.vue?vue&type=script&lang=js"
export * from "./AppEventview.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__